/**
 * Демо страница MdmTable => ReactiveTable
 */
import { observer } from "mobx-react-lite";
import React, { useMemo, useState } from "react";
import { MdmTable } from "src/components/MdmTable";
import {
  multiSortClickHandler,
  singleSortClickHandler,
} from "src/components/ReactiveTable/ctrl";
import { RtStore } from "src/components/ReactiveTable/RtStore";

import { createColumns } from "./columns";
import * as styles from "./CustomTableDemo.module.less";
import { createDataLoader } from "./dataLoader";
import { createColumnFilters } from "./filters";
import { TableControls } from "./TableControls";
import { User, UserFilters } from "./types";

export const CustomTableDemo: React.FC = observer(() => {
  // State для настроек таблицы
  const [resizableColumns, setResizableColumns] = useState(true);
  const [selectionType, setSelectionType] = useState<
    "checkbox" | "radio" | undefined
  >("checkbox");
  const [verticalMode, setVerticalMode] = useState<"fit" | "limit" | "normal">(
    "fit",
  );
  const [fixedLeft, setFixedLeft] = useState(0);
  const [fixedRight, setFixedRight] = useState(0);
  const [sortMode, setSortMode] = useState<"multi" | "single">("multi");

  // Создаем store
  const store = useMemo(
    () =>
      new RtStore<User, UserFilters>({
        rowKey: "id",
        sortClickHandler:
          sortMode === "multi" ? multiSortClickHandler : singleSortClickHandler,
        loader: createDataLoader(),
        defaultRequest: {
          page: 1,
          pageSize: 20,
          sortOrder: [{ columnKey: "id", mode: "ascend" }],
          filters: {},
        },
        selectionType,
      }),
    [selectionType, sortMode],
  );

  // Обновляем фиксированные колонки
  React.useEffect(() => {
    store.changeFixedLeftRaw(fixedLeft);
  }, [fixedLeft, store]);

  React.useEffect(() => {
    store.changeFixedRightRaw(fixedRight);
  }, [fixedRight, store]);

  // Загружаем данные при монтировании
  React.useEffect(() => {
    store.reload().catch(() => {
      // Error handling
    });
  }, [store]);

  // Определяем колонки
  const columns = useMemo(() => createColumns(), []);

  // Фильтры
  const columnFilters = useMemo(() => createColumnFilters(store), [store]);

  return (
    <div className={styles.demoPage}>
      <div className={styles.header}>
        <h1>ReactiveTable - Демо</h1>
        <p>
          Модульная реактивная таблица с полной поддержкой замены компонентов
        </p>
      </div>

      <TableControls
        store={store}
        resizableColumns={resizableColumns}
        onResizableColumnsChange={setResizableColumns}
        verticalMode={verticalMode}
        onVerticalModeChange={setVerticalMode}
        sortMode={sortMode}
        onSortModeChange={setSortMode}
        selectionType={selectionType}
        onSelectionTypeChange={setSelectionType}
        fixedLeft={fixedLeft}
        onFixedLeftChange={setFixedLeft}
        fixedRight={fixedRight}
        onFixedRightChange={setFixedRight}
      />

      <div
        className={styles.tableWrapper}
        style={{ height: verticalMode === "fit" ? 600 : "unset" }}
      >
        <MdmTable
          store={store}
          columns={columns}
          verticalMode={verticalMode}
          resizableColumns={resizableColumns}
          columnFilters={columnFilters}
          showTotal={(count) => `Всего найдено: ${count} пользователей`}
          // cellHandler={{
          //   type: "click",
          //   onClick(row) {
          //     console.log(row);
          //   },
          // }}
        />
      </div>
    </div>
  );
});
